import React from 'react';
import { Line } from '@react-three/drei';

import { Point2D } from '@paragon/geometry-library';

import { useAppSelector } from '../../../components/hooks';
import { convertFromLayoutToDesignCoordinates } from '../../../library/layout-geometry/coordinates';
import { AlignmentGuide, getAlignmentGuides } from '../../../store/selectors/bearingEnvelopeGuideSelectors';
import { layoutColors } from '../layoutColors';
import { FLAT_BEARING_Z_HEIGHT } from './BearingFlatVisual';

function GuideLine({ guide }: { guide: AlignmentGuide }) {
  const p1 = guide.axis === 'x' ? new Point2D(guide.value, guide.from) : new Point2D(guide.from, guide.value);
  const p2 = guide.axis === 'x' ? new Point2D(guide.value, guide.to) : new Point2D(guide.to, guide.value);

  const start = convertFromLayoutToDesignCoordinates(p1.to3D(FLAT_BEARING_Z_HEIGHT)).toArray();
  const end = convertFromLayoutToDesignCoordinates(p2.to3D(FLAT_BEARING_Z_HEIGHT)).toArray();

  return (
    <Line
      dashed
      depthTest={false}
      lineWidth={1}
      color={layoutColors.entitySnap}
      dashSize={3}
      gapSize={2}
      points={[start, end]}
    />
  );
}

export function AlignmentGuidesVisual() {
  const guides = useAppSelector(getAlignmentGuides);

  if (guides.length === 0) return null;

  return (
    <>
      {guides.map((guide, i) => (
        <GuideLine key={`${guide.axis}-${guide.value}-${i}`} guide={guide} />
      ))}
    </>
  );
}
